export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '亲吻姐姐一共有多少集？',
    answer: '亲吻姐姐TV动画共有12集，此外还有多部OAD（随漫画单行本附赠）和OVA特别篇。完整观看建议按照TV版 → OAD系列 → 特别篇的顺序。',
  },
  {
    question: '亲吻姐姐的结局是什么？圭太最后和谁在一起了？',
    answer: '亲吻姐姐采用了开放式的结局，圭太并没有明确选择亚香或理香中的任何一人。他意识到两位姐姐在他生命中不可替代的重要性，三人约定无论未来如何变化，都要一直在一起。这种开放式的结局给了粉丝无限的想象空间。',
  },
  {
    question: '亲吻姐姐在哪里可以看？',
    answer: '亲吻姐姐的TV动画和OVA系列在日本可通过多家流媒体平台观看。由于版权原因，不同地区的观看渠道可能有所不同，建议通过正规渠道支持正版。',
  },
  {
    question: '亲吻姐姐的声优阵容有哪些？',
    answer: '亲吻姐姐拥有豪华的声优阵容：住之江亚香由竹达彩奈配音，住之江理香由佐藤聪美配音，住之江圭太由武内健配音。声优们的精彩演绎为角色注入了鲜活的生命力。',
  },
  {
    question: '亲吻姐姐和原作漫画有什么不同？',
    answer: '亲吻姐姐的原作漫画由ぢたま(某)创作，TV动画在改编时保持了漫画的核心剧情和风格，但部分情节有所调整和删减。OAD系列则更加忠实于原作漫画。如果喜欢动画，强烈推荐阅读原作漫画以获得更完整的体验。',
  },
  {
    question: '亲吻姐姐适合什么年龄段的观众观看？',
    answer: '亲吻姐姐是一部以校园恋爱为主题的动漫作品，整体风格偏向青少年向。建议15岁及以上的观众观看。作品在恋爱描写上较为含蓄温馨，但部分OVA内容尺度会稍大，观看时请根据个人情况选择。',
  },
];